import * as React from "react";

export default () => (
  <div style={{ textAlign: "center", color: "#999", fontSize: "0.8em" }}>
    © {new Date().getFullYear()} American Corporate Partners.
  </div>
);
